import { render, staticRenderFns } from "./LightSimple.vue?vue&type=template&id=6dd3c40c&scoped=true"
import script from "./LightSimple.vue?vue&type=script&lang=js"
export * from "./LightSimple.vue?vue&type=script&lang=js"
import style0 from "./LightSimple.vue?vue&type=style&index=0&id=6dd3c40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3c40c",
  null
  
)

export default component.exports